<template>
  <div id="forgot">
    <!-- <TheNavigationPanel/> -->
      <v-container
        class="fill-height"
        fluid
        >
        <v-snackbar v-model="snackbar" :timeout="10000" top color="success">
          <span>Verification Email Sent To Your Mail...</span>
          <v-btn text color="white" @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-snackbar v-model="snackbar1" :timeout="10000" top color="red">
          <span>{{errMsg}}</span>
          <v-btn text color="white" @click="snackbar1 = false">Close</v-btn>
        </v-snackbar>
        <v-row
          justify="center"
          allign="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="6"
          >
            <v-card class="pa-12 mx-auto mt-12" id="login" max-width="500px" elevation="7">
              <h4 class="text-center" style="color:#1a00d4">Forgot Password</h4>
              <p class="text-center my-4">A link will be sent to your mailbox to enter new password.</p>               
                <v-card-text>
                  <v-form>
                  <v-text-field
                    label="Enter your username"
                    v-model="username" :rules="usernameRules" 
                    prepend-inner-icon="mdi-account"
                    type="text" single-line
                    solo required color="#1a00d4"
                  ></v-text-field>
                  <v-text-field
                    label="Enter your Email"
                    v-model="email" :rules="emailRules" 
                    prepend-inner-icon="mdi-mail"
                    type="text" single-line
                    solo required color="#1a00d4"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-text class="text-center mt-n8">
                <v-btn style="color:#1a00d4" class="" v-on:click="reset()" :loading="loading">
                    Submit
                </v-btn>
                </v-card-text>

                <v-list-item>
                 <v-btn text  class="forgot" router-link to="/login" color="#1a00d4">
                    <v-icon left>mdi-chevron-left</v-icon>
                      Back to Login
                </v-btn>
                </v-list-item>
            </v-card>
          </v-col>
        </v-row> 
      </v-container>
  </div>
    
</template>

<script>
// import TheNavigationPanel from '../components/TheNavigationPanel';

export default {
    components:{
      // TheNavigationPanel
    },
    data(){
        return{
            username: '',
            email: '',
            loading:false,
            snackbar: false,
            snackbar1: false,
            usernameRules:[
                v => !!v || 'Username is required',
            ],
            emailRules: [
               v => !!v || 'Email is required',
               v => /.+@.+/.test(v) || 'Email must be valid',
            ],
            errMsg:''
        }
    },
    methods:{
        reset(){
          this.loading=true
          this.$store.dispatch("forgotPassword",{
            "username": this.username,
            "email": this.email
          })
        .then((success)=>{
          console.log(success);
          this.loading = false
          this.snackbar = true;
          this.username = ""
          this.email = ""
        })
        .catch((error)=>{
          this.loading = false
          this.errMsg= error.response.data
          this.snackbar1 = true
        })
     }
    }
}
</script>

<style scoped>

.v-card:not(.v-sheet--tile) {
    border-radius: 28px;
}
.forgot-color{
 color:#5F5D5D;   
}
.size{
    font-size: 15px;
}
#login{
    border-radius: 5px;
}
.forgot{
    text-transform: capitalize;
}
</style>